import "./CircleChart.scss";

function CircleChart({
  segments,
  size = 150,
  strokeWidth = 12,
  centerValue,
  centerLabel,
  showLegend = false,
  legendPosition = "bottom", // "bottom", "right", "left", "top"
  showValues = false, // Show actual values instead of percentages in legend
  animate = true, // Enable/disable animations
}) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const center = size / 2;

  // Calculate segment offsets
  let currentOffset = 0;
  const segmentsWithOffsets = segments.map((segment) => {
    const segmentLength = (segment.percentage / 100) * circumference;
    const result = {
      ...segment,
      offset: currentOffset,
      length: segmentLength,
    };
    currentOffset += segmentLength;
    return result;
  });

  return (
    <div
      className={`circle-chart circle-chart--${legendPosition} ${animate ? "circle-chart--animated" : ""}`}
    >
      <svg width={size} height={size}>
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="var(--bars-border-color)"
          strokeWidth={strokeWidth}
          opacity="0.2"
        />

        {/* Segments */}
        {segmentsWithOffsets.map((segment, index) => (
          <circle
            key={index}
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke={segment.color}
            strokeWidth={strokeWidth}
            strokeDasharray={
              animate
                ? circumference
                : `${segment.length} ${circumference - segment.length}`
            }
            strokeDashoffset={animate ? circumference : -segment.offset}
            strokeLinecap="butt"
            transform={`rotate(-90 ${center} ${center})`}
            className="segment"
            style={{
              "--segment-length": segment.length,
              "--segment-offset": -segment.offset,
            }}
          />
        ))}

        {/* Center text */}
        {centerValue && (
          <>
            <text
              x="50%"
              y="43%"
              textAnchor="middle"
              dy=".3em"
              className="center-value"
            >
              {centerValue}
            </text>
            {centerLabel && (
              <text
                x="50%"
                y="70%"
                textAnchor="middle"
                className="center-label"
              >
                {centerLabel}
              </text>
            )}
          </>
        )}
      </svg>

      {/* Legend */}
      {showLegend && (
        <div className="chart-legend">
          {segments.map((segment, index) => (
            <div key={index} className="legend-item">
              <div
                className="legend-color"
                style={{ backgroundColor: segment.color }}
              />
              <span className="legend-label">{segment.label}</span>
              <span className="legend-value">
                {showValues && segment.value !== undefined
                  ? segment.value
                  : `${segment.percentage.toFixed(2)}%`}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CircleChart;
